// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sticky-navigation[data-v-3e85db10]{max-width:50rem;min-height:11.4rem;padding-top:2.8rem;margin-left:auto;margin-right:auto}.sticky-navigation .line[data-v-3e85db10]{position:absolute;height:.4rem;width:2.4rem;--bg-opacity:1;background-color:#1d4ed8;background-color:rgba(29,78,216,var(--bg-opacity));margin-bottom:2px;bottom:3.2rem;transition:left .4s ease-in-out}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
